import React, { useEffect, useState } from 'react';
import { awards } from '../data/mockData';
import { COLORS, SPACING } from '../constants/designSystem';
import { Award, Trophy, FileCheck, Users } from 'lucide-react';

const AwardsPage = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  const categoryIcons = {
    'Industry Recognition': Trophy,
    Competition: Award,
    Certification: FileCheck,
    'Academic Honor': Award,
    Community: Users,
  };

  return (
    <div style={{ backgroundColor: COLORS.background, minHeight: '100vh', paddingTop: '80px' }}>
      {/* Hero */}
      <section
        style={{
          padding: `${SPACING.xxxl} ${SPACING.lg}`,
          textAlign: 'center',
          background: `radial-gradient(circle at 50% 50%, ${COLORS.primary}08 0%, transparent 60%)`,
        }}
      >
        <div
          style={{
            maxWidth: '800px',
            margin: '0 auto',
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
            transition: 'all 600ms cubic-bezier(0.4, 0, 0.2, 1)',
          }}
        >
          <div
            style={{
              display: 'inline-block',
              padding: `${SPACING.xs} ${SPACING.md}`,
              backgroundColor: `${COLORS.primary}15`,
              border: `1px solid ${COLORS.primary}40`,
              borderRadius: '50px',
              marginBottom: SPACING.md,
            }}
          >
            <span style={{ fontSize: '14px', color: COLORS.primary, fontWeight: '500' }}>Achievements</span>
          </div>
          <h1
            style={{
              fontSize: '56px',
              fontWeight: '700',
              color: COLORS.text.primary,
              marginBottom: SPACING.md,
            }}
          >
            Awards & Recognition
          </h1>
          <p
            style={{
              fontSize: '18px',
              lineHeight: '1.6',
              color: COLORS.text.secondary,
            }}
          >
            Celebrating milestones, certifications, and contributions to the tech community
          </p>
        </div>
      </section>

      {/* Awards Timeline */}
      <section style={{ padding: `${SPACING.xl} ${SPACING.lg} ${SPACING.xxxl}` }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          {awards.map((award, index) => {
            const Icon = categoryIcons[award.category] || Award;
            return (
              <div
                key={award.id}
                style={{
                  display: 'flex',
                  gap: SPACING.lg,
                  marginBottom: SPACING.xxl,
                  opacity: isVisible ? 1 : 0,
                  transform: isVisible ? 'translateX(0)' : 'translateX(-20px)',
                  transition: `all 600ms cubic-bezier(0.4, 0, 0.2, 1) ${index * 100}ms`,
                }}
                className="award-item"
              >
                {/* Icon */}
                <div
                  style={{
                    flexShrink: 0,
                    width: '64px',
                    height: '64px',
                    backgroundColor: `${COLORS.primary}15`,
                    border: `2px solid ${COLORS.primary}`,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Icon size={28} color={COLORS.primary} strokeWidth={2} />
                </div>

                {/* Content */}
                <div
                  style={{
                    flex: 1,
                    padding: SPACING.lg,
                    backgroundColor: COLORS.cardSurface,
                    border: `1px solid ${COLORS.border}`,
                    borderRadius: '16px',
                    transition: 'all 300ms',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = COLORS.primary;
                    e.currentTarget.style.transform = 'translateX(8px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = COLORS.border;
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'flex-start',
                      marginBottom: SPACING.sm,
                      flexWrap: 'wrap',
                      gap: SPACING.sm,
                    }}
                  >
                    <div>
                      <h3
                        style={{
                          fontSize: '24px',
                          fontWeight: '600',
                          color: COLORS.text.primary,
                          marginBottom: '4px',
                        }}
                      >
                        {award.title}
                      </h3>
                      <p
                        style={{
                          fontSize: '16px',
                          color: COLORS.primary,
                          fontWeight: '500',
                        }}
                      >
                        {award.organization}
                      </p>
                    </div>
                    <div
                      style={{
                        padding: `${SPACING.xs} ${SPACING.md}`,
                        backgroundColor: `${COLORS.primary}20`,
                        border: `1px solid ${COLORS.primary}40`,
                        borderRadius: '8px',
                        fontSize: '14px',
                        fontWeight: '600',
                        color: COLORS.primary,
                      }}
                    >
                      {award.year}
                    </div>
                  </div>
                  <p
                    style={{
                      fontSize: '15px',
                      lineHeight: '1.6',
                      color: COLORS.text.secondary,
                      marginBottom: SPACING.sm,
                    }}
                  >
                    {award.description}
                  </p>
                  <span
                    style={{
                      display: 'inline-block',
                      fontSize: '12px',
                      color: COLORS.text.muted,
                      padding: '4px 10px',
                      backgroundColor: COLORS.surface,
                      borderRadius: '6px',
                    }}
                  >
                    {award.category}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <style>{`
        @media (max-width: 768px) {
          .award-item {
            flex-direction: column;
          }
        }
      `}</style>
    </div>
  );
};

export default AwardsPage;
